import { IonCard, IonCardContent, IonRow } from '@ionic/react';
import { DqText } from '../../components/dq-text';
import React, { FC } from 'react';
import { JobReportGuestAuthMessages } from '../../intl/JobReportGuestAuthMessages';
import { useIntl } from 'react-intl';
import { FailureType } from '../../redux/logInfo/types';

export interface ShareValidationMessageCardProps {
  failureType: FailureType;
  messageParams: Record<string, string>;
}

export const ShareValidationMessageCard: FC<ShareValidationMessageCardProps> = ({ failureType, messageParams }) => {
  const { formatMessage } = useIntl();

  let messageTitleId;
  let messageId;
  switch (failureType) {
    case FailureType.NotSharedWithUser: {
      messageTitleId = JobReportGuestAuthMessages.notSharedWithThisUserTitle;
      messageId = JobReportGuestAuthMessages.notSharedWithThisUserMessage;
      break;
    }
    case FailureType.ShareExpired: {
      messageTitleId = JobReportGuestAuthMessages.shareLinkExpiredTitle;
      messageId = JobReportGuestAuthMessages.shareLinkExpiredMessage;
      break;
    }
    case FailureType.LogNotFound: {
      messageTitleId = JobReportGuestAuthMessages.logInfoNotFoundTitle;
      messageId = JobReportGuestAuthMessages.logInfoNotFoundMessage;
      break;
    }
    default: {
      messageTitleId = JobReportGuestAuthMessages.internalErrorTitle;
      messageId = JobReportGuestAuthMessages.internalErrorMessage;
    }
  }

  return (
    <IonCard className="content-card">
      <IonCardContent>
        <IonRow>
          <DqText variant="h3" color="dark">
            {formatMessage(messageTitleId)}
          </DqText>
        </IonRow>
        <IonRow>
          <DqText className="ion-margin-vertical" variant="body" color="dark">
            {formatMessage(messageId, messageParams)}
          </DqText>
        </IonRow>
      </IonCardContent>
    </IonCard>
  );
};
